import { CentralStationNewContactDto } from './CentralStationNewContactDto';
import { CentralStationContactPatientUpdateRequestDto } from './CentralStationContactPatientUpdateRequestDto';
import { CentralStationContactMedicalConditionDto } from './CentralStationContactMedicalConditionDto';
import { CentralStationContactAllergyConditionDto } from './CentralStationContactAllergyConditionDto';
export class CentralStationContactWithMedicalInformationDto {
    NewContact: CentralStationNewContactDto;
    ContactPatientUpdateRequest: CentralStationContactPatientUpdateRequestDto;
    ContactMedicalConditions: CentralStationContactMedicalConditionDto[];
    ContactAllergyConditions: CentralStationContactAllergyConditionDto[];
}